import React, { useEffect, createElement } from 'react';
import { CountdownTimer } from './components/CountdownTimer';
import { PurchasePopup } from './components/PurchasePopup';
import { HeroSection } from './components/HeroSection';
import { SalesContent } from './components/SalesContent';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusSection } from './components/BonusSection';
import { PurchaseSection } from './components/PurchaseSection';
import { FAQSection } from './components/FAQSection';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '3070568583125644');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `
      <img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=3070568583125644&ev=PageView&noscript=1"
      />
    `;
    document.body.appendChild(noscript);
    return () => {
      // Cleanup if necessary, though usually pixels stay for the session
    };
  }, []);
  return <div className="min-h-screen bg-slate-950 text-slate-100 font-sans selection:bg-[#FF6B35] selection:text-white" data-id="element-0">
      <CountdownTimer data-id="element-1" />

      <main className="relative" data-id="element-2">
        <HeroSection data-id="element-3" />
        <SalesContent data-id="element-4" />
        <TestimonialsSection data-id="element-5" />
        <BonusSection data-id="element-6" />
        <PurchaseSection data-id="element-7" />

        {/* Not For You / For You Summary */}
        <section className="py-16 px-4 bg-slate-900 border-t border-slate-800" data-id="element-8">
          <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-9">
            <div className="p-6 rounded-lg bg-red-950/20 border border-red-900/30" data-id="element-10">
              <h3 className="font-bold text-red-400 mb-4 text-lg" data-id="element-11">
                🚫 ESTO NO ES PARA TI SI...
              </h3>
              <ul className="space-y-2 text-slate-400 text-sm" data-id="element-12">
                <li data-id="element-13">• Buscas manipular a las personas</li>
                <li data-id="element-14">• Quieres "trucos rápidos" sin cambiar mentalidad</li>
                <li data-id="element-15">• No estás dispuesto a trabajar en tu seguridad</li>
              </ul>
            </div>
            <div className="p-6 rounded-lg bg-green-950/20 border border-green-900/30" data-id="element-16">
              <h3 className="font-bold text-green-400 mb-4 text-lg" data-id="element-17">
                💡 PARA QUIÉN SÍ ES
              </h3>
              <ul className="space-y-2 text-slate-400 text-sm" data-id="element-18">
                <li data-id="element-19">• Personas que quieren dejar de sentirse invisibles</li>
                <li data-id="element-20">
                  • Quienes ya se cansaron de intentarlo sin entender qué falla
                </li>
                <li data-id="element-21">• Personas que quieren conectar sin actuar un personaje</li>
              </ul>
            </div>
          </div>
        </section>

        <FAQSection data-id="element-22" />

        <footer className="py-12 bg-black text-center text-slate-600 text-sm" data-id="element-23">
          <p data-id="element-24">
            © {new Date().getFullYear()} ATRACCIÓN REAL™. Todos los derechos
            reservados.
          </p>
          <p className="mt-2" data-id="element-25">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          </p>
        </footer>
      </main>

      <PurchasePopup data-id="element-26" />
    </div>;
}